<template>
  <div :class="starsCssClasses">
    <div class="c-stars__inner">
      <ul class="c-stars__list">
        <li v-for="n in 5" :key="n" class="c-stars__list__item">
          <span :class="icoCssClasses">
            <svg>
              <use xlink:href="#svg-icon-star-silver"></use>
            </svg>
          </span>
        </li>
      </ul>
      <div class="c-stars__progress">
        <ul class="c-stars__list">
          <li v-for="n in 5" :key="n" class="c-stars__list__item">
            <span :class="icoCssClasses">
              <svg>
                 <use xlink:href="#svg-icon-star-gold"></use>
              </svg>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <slot name="bottom" />
  </div>
</template>
<script>
import {roundToHalf} from '@/shared/math'

export default {
  props: {
    rating: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      default: 'm'
    },
    inline: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    starsCssClasses () {
      const rating = roundToHalf(this.rating) * 2

      const css = [`c-stars c-stars--p${rating}`]

      css.push(`c-stars--${this.size}`)

      if (this.inline) {
        css.push('c-stars--inline')
      }

      if (this.centered) {
        css.push('c-stars--center')
      }

      return css.join(' ')
    },

    icoCssClasses () {
      return `o-ico o-ico--star o-ico--${this.size}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CStars.vue